module.exports = __webpack_public_path__ + "fonts/10e4ff0f0786ca6e9a75283eb6997f07.svg";